import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Modal from '@mui/material/Modal';

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DataGridTable from "examples/Tables/DataGridTable";

const ContactDeviceAccessTableView = ({ contacts, selectedContacts, setSelectedContacts }) => {
    const [open, setOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);

    const getRows = (info) => {
        let updatedInfo = info.map((row) => {
            let phone = row?.Contact?.ContactAddresses.find(contact => contact.address_type_id === 1 && contact.is_default === true);
            let email = row?.Contact?.ContactAddresses.find(contact => contact.address_type_id === 2 && contact.is_default === true);
            let fax = row?.Contact?.ContactAddresses.find(contact => contact.address_type_id === 3 && contact.is_default === true);
            return {
                type: "contacts",
                id: row.Contact?.contact_id,
                first_name: row.Contact?.first_name,
                last_name: row.Contact?.last_name,
                type: row.Contact?.ContactType?.type_name,
                phone: phone ? phone.contact_address : '', // Render phone.contact_address if phone exists, otherwise an empty string
                email: email ? email.contact_address : '', // Render email.contact_address if email exists, otherwise an empty string
                fax: fax ? fax.contact_address : '',
            };
        });
        return updatedInfo;
    };

    const dataTableAllData = {
        columns: [
            { headerName: "Type", field: "type", flex: 1 },
            { headerName: "Id", field: "id", flex: 1 },
            { headerName: "First Name", field: "first_name", flex: 1 },
            { headerName: "Last Name", field: "last_name", flex: 1 },
            { headerName: "Phone", field: "phone", flex: 1 },
            { headerName: "Email", field: "email", flex: 1 },
            { headerName: "Fax", field: "fax", flex: 1 },
        ],

        rows: getRows(contacts),
    };

    const handleOpen = () => {
        setSelectedRows([...selectedContacts]);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const saveHandler = () => {
        const updatedRows = [...selectedRows];
        setSelectedContacts(updatedRows);
        setSelectedRows(updatedRows)
        setOpen(false);
    }

    return (
        <MDBox display="flex" flexDirection="column" style={{ marginTop: "1rem" }}>
            <MDBox
                display="flex"
            >
                <MDTypography fontWeight="bold">
                    Contact Device Access
                </MDTypography>
                <MDButton variant="gradient" color="dark" size="small" style={{ marginLeft: "1rem" }} onClick={handleOpen}>Select Contact</MDButton>
            </MDBox>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Card
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%', // Set the desired width here
                        backgroundColor: 'white',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    {/* <CardContent> */}
                    <DataGridTable title="Contact Management" rowData={getRows(contacts)} columns={dataTableAllData.columns} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />
                    <MDBox ml="auto" mt={3} display="flex" justifyContent="flex-end">
                        <MDButton variant="contained" color="secondary" onClick={handleClose}>
                            Cancel
                        </MDButton>
                        <MDButton variant="contained" color="info" onClick={saveHandler} style={{ marginLeft: '10px' }}>
                            Save
                        </MDButton>
                    </MDBox>
                    {/* </CardContent> */}
                </Card>
            </Modal>
        </MDBox>
    );
};

export default ContactDeviceAccessTableView;
